module.exports = __webpack_public_path__ + "img/49_15.088282cd.png";